import { CircularProgress } from "@mui/material"
import CircularContainer from "../common/containers/CircularContainer";

const LoadingCircle = () => {
    return (
        <CircularContainer>
            <CircularProgress />
        </CircularContainer>
    )
}

export default LoadingCircle;